import api from '@/api';
import { API_BASE_URL } from '..';

export default async function commonGenerateNetReport<P>(
  URL = '',
  params?: P,
  isPocReport?: boolean,
) {
  const BASE_URL = isPocReport
    ? API_BASE_URL.replace('net-report', 'report-poc')
    : API_BASE_URL;
  const result = (await api.getReport(BASE_URL + URL, params)) as unknown;
  return result as BlobPart;
}
